import { $, $$, on, setAttr, removeAttr } from "../../utils/dom";
import { updateServiceCategoryCounts } from "../categoryListFilter/categoryListFilter";

const NON_STANDARD_HIDDEN_CLASS = "is-hidden--non-standard";

// Hides service list items whose data flag says they are not standard services,
// and collapses categories that have no standard services to keep the view tidy.
const applyStandardOnlyFilter = (
  wrapper: HTMLElement,
  isActive: boolean
): void => {
  const items = wrapper.querySelectorAll<HTMLElement>(
    "[data-service-catalog-standard-service]"
  );
  items.forEach((item) => {
    const isStandard = item.dataset.serviceCatalogStandardService === "true";
    item.classList.toggle(NON_STANDARD_HIDDEN_CLASS, isActive && !isStandard);
  });

  const categories = wrapper.querySelectorAll<HTMLElement>(
    ".m-services__category"
  );
  categories.forEach((category) => {
    const hasStandardService = !!category.querySelector(
      '[data-service-catalog-standard-service="true"]'
    );
    category.classList.toggle(
      NON_STANDARD_HIDDEN_CLASS,
      isActive && !hasStandardService
    );
  });

  updateServiceCategoryCounts(wrapper);
};

export const onContentLoaded = (): void => {
  const servicesWrapper = $(".m-services");
  const toggleButton = $(".js-toggle-button");
  const showOnlyStandardServicesButtons = $$(
    ".js-show-only-standard-services-button"
  );
  const services = $$(".m-services__category");

  showOnlyStandardServicesButtons?.forEach((button) => {
    const wrapper = button.closest<HTMLElement>(".m-services");
    if (!wrapper) return;

    on(button, "click", () => {
      const isPressed = button.getAttribute("aria-pressed") === "true";
      const nextState = !isPressed;
      setAttr(button, "aria-pressed", nextState ? "true" : "false");
      applyStandardOnlyFilter(wrapper, nextState);
    });
  });

  if (toggleButton && services) {
    new MutationObserver(function (mutationList) {
      for (const mutation of mutationList) {
        const target = mutation.target as HTMLElement;

        target.getAttribute("js-open-all") === "true"
          ? services.forEach(function (accordion) {
              setAttr(accordion, "open", "");
            })
          : services.forEach(function (accordion) {
              removeAttr(accordion, "open");
            });
      }
    }).observe(toggleButton, {
      attributes: true,
      attributeFilter: ["js-open-all"],
    });

    servicesWrapper &&
      new MutationObserver(function (mutationList) {
        for (const mutation of mutationList) {
          const target = mutation.target as HTMLElement;
          const mutationIsOpenDetails = target.getAttribute("open") !== null;

          if (!mutationIsOpenDetails) {
            return setAttr(toggleButton, "aria-pressed", "false");
          }

          if (
            mutationIsOpenDetails &&
            toggleButton.getAttribute("aria-pressed") === "false"
          ) {
            Array.from(services).every(
              (service) => service.getAttribute("open") === ""
            ) && setAttr(toggleButton, "aria-pressed", "true");
          }
        }
      }).observe(servicesWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["open"],
      });
  }
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
